import { checkCardInFilters, getSameAction, toFixed } from '../helpers/helpers'
import { getReducedArrBiggestAction } from '../Redux/_actions/helpers'

export const parseStreetQuery = (curPath, boardArr) => {
	let newQuery = curPath

	const flop = `F.${boardArr[0]}${boardArr[1]}${boardArr[2]}`
	const turn = `T.${boardArr[3]}`
	const river = `R.${boardArr[4]}`

	const flopRegExp = new RegExp('F\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){3}')
	const turnRegExp = new RegExp('T\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){1}')
	const riverRegExp = new RegExp('R\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){1}')

	if (flop.indexOf('-') === -1) {
		newQuery = newQuery.replace(flopRegExp, flop)
	}

	if (turn.indexOf('-') === -1) {
		newQuery = newQuery.replace(turnRegExp, turn)
	}

	if (river.indexOf('-') === -1) {
		newQuery = newQuery.replace(riverRegExp, river)
	}

	return newQuery
}

export const getMaxMinMatrixCellValue = ({ isStrategy, structure, combos, draws, suits, field, threshold }) => {
	let absMatrixMax = 0.0
	let fieldMatrixMax = 0.0
	let fieldMatrixMin = 0.0

	let absHandMax = 0

	const availableAction = structure?.find((item) => item)

	for (let i = 0; i < 13; i += 1) {
		for (let j = 0; j < 13; j += 1) {
			let sum = 0.0
			let fieldSum = 0.0
			let count = 0.0

			const cards = !isStrategy ? structure?.[i + 13 * j]?.c : availableAction?.values?.[i + 13 * j]?.c

			for (let k = 0; k < cards?.length; k++) {
				const card = cards?.[k]

				const isCardInFilters = checkCardInFilters(card, combos, draws, suits, threshold, field)

				const fieldValue = field === 'abs' ? card[field] : card[field] / 100

				if (isCardInFilters) {
					sum += card.abs
					fieldSum += fieldValue
					count++

					absHandMax = card.abs > absHandMax ? card.abs : absHandMax
				}
			}

			sum /= count
			fieldSum /= count

			absMatrixMax = sum > absMatrixMax ? sum : absMatrixMax
			fieldMatrixMax = fieldSum > fieldMatrixMax ? fieldSum : fieldMatrixMax
			fieldMatrixMin = fieldSum < fieldMatrixMin ? fieldSum : fieldMatrixMin
		}
	}

	return { absMatrixMax, fieldMatrixMax, fieldMatrixMin, absHandMax }
}

export const getViewerPositions = ({ librariesResponse, spotId, activePlayer, villainPlayer }) => {
	const gamePos =
		librariesResponse &&
		spotId &&
		librariesResponse.libraries
			.map((item) => item.spots)
			.flat()
			.find((item) => item.spot_id === Number(spotId)).all_positions
	const positions = gamePos && gamePos.filter((el) => el === activePlayer || el === villainPlayer)

	return positions
}

export const getBoardByQuery = (query) => {
	const board = ['-', '-', '-', '-', '-']

	const fRe = 'F\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){3}'
	const tRe = 'T\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){1}'
	const rRe = 'R\\.([A,K,Q,J,T,9,8,7,6,5,4,3,2][sdch]){1}'

	const flop = query.match(fRe)
	const turn = query.match(tRe)
	const river = query.match(rRe)

	if (flop !== null) {
		board[0] = flop[0].substring(2, 4)
		board[1] = flop[0].substring(4, 6)
		board[2] = flop[0].substring(6, 8)
	}

	if (turn !== null) {
		board[3] = turn[0].substring(2, 4)
	}

	if (river !== null) {
		board[4] = river[0].substring(2, 4)
	}

	return board
}

export const calcSizingsSunburst = (current, previous, pot) => {
	if (current.startsWith('Bet')) {
		const valueBet = +current.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)

		return `Bet ${toFixed((valueBet / pot) * 100, 0)}%`
	}

	if (current.includes('Call')) {
		return current.slice(0, 4)
	}

	if (current.startsWith('Raise')) {
		const valueRaise = +current.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)
		let previousAction = +previous.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)

		return `Raise ${toFixed(valueRaise / previousAction, 2)}x`
	}

	return current
}

export const getAbs = (isStrategy, vals, weight, filter, threshold, absMatrixMax, s1, s2) => {
	let sum = 0.0
	let abs = 0.0
	let cnt = 0

	const commonFiltersCondition = ({ cards, filter }) => {
		cards.forEach((c) => {
			const holeSuit = c.s[1] + c.s[3]
			const checkCombo = filter.combos.includes(c.com)
			const checkDraw = filter.draws.includes(c.draw)
			const checkSuits = filter.suits.includes(holeSuit)

			if (s1 && s2 && c.s[1] === s1 && c.s[3] === s2 && checkCombo && checkDraw && checkSuits && c.abs > threshold) {
				sum += c.val * c.abs
				abs += c.abs
				cnt++
			}

			if (!s1 && !s2 && checkCombo && checkDraw && checkSuits && c.abs > threshold) {
				sum += c.val
				abs += c.abs
				cnt++
			}
		})
	}

	if (isStrategy) {
		vals?.forEach((a) => {
			if (!a) {
				return
			}
			// get the sum of %
			commonFiltersCondition({ cards: a.cards.c, filter })
		})
	}

	if (!isStrategy) {
		commonFiltersCondition({ cards: vals && vals, filter })
	}

	if (weight === 'normalized') {
		abs /= cnt
		abs /= absMatrixMax
	} else if (weight === 'absolute') {
		abs /= cnt
	} else if (weight) {
		abs = 1.0
	}

	return [abs, sum]
}

export const getGradient = (cellVals, filter, getColor, threshold, s1, s2, isDrawReverseActions) => {
	const gradient = []

	const drawVals = isDrawReverseActions ? cellVals.slice().reverse() : cellVals
	let sum = 0

	for (let i = 0; i < drawVals?.length; i++) {
		if (!drawVals[i]) {
			continue
		}

		drawVals[i].cards.c.forEach((card) => {
			const holeSuit = card.s[1] + card.s[3]
			const checkCombo = filter.combos.includes(card.com)
			const checkDraw = filter.draws.includes(card.draw)
			const checkSuits = filter.suits.includes(holeSuit)

			if (
				s1 &&
				s2 &&
				card.s[1] === s1 &&
				card.s[3] === s2 &&
				checkCombo &&
				checkDraw &&
				checkSuits &&
				card.abs > threshold
			) {
				sum += card.val
			}

			if (!s1 && !s2 && checkCombo && checkDraw && checkSuits && card.abs > threshold) {
				sum += card.val
			}
		})

		const gradientColor = getColor(drawVals[i].action, drawVals[i].raiseIndex, drawVals[i].isAllIn)

		gradient.push(`linear-gradient(to right, ${gradientColor} , ${gradientColor})`)
	}

	return sum > 0 ? gradient : null
}

export const getGradientWidth = (
	cellVals,
	filter,
	threshold,
	weight,
	absMatrixMax,
	isStrategy,
	isMultiStack,
	s1,
	s2,
	isDrawReverseActions
) => {
	const gradientWidthArray = []
	let gradientWidth = 0

	const drawVals = isDrawReverseActions ? cellVals.slice().reverse() : cellVals

	let [abs, sum] = getAbs(isStrategy, drawVals, weight, filter, threshold, absMatrixMax, s1, s2)

	if (sum === 0) {
		return '100% 100%'
	}

	if (!isStrategy && sum !== 0) {
		let weightHeight = ((50 * abs) / 50) * 100
		gradientWidthArray.push(`100% ${weightHeight}%`)
	}

	if (isStrategy) {
		drawVals?.forEach((action) => {
			if (!action) {
				return
			}

			// get the sum of %
			let a_sum = 0.0
			let action_abs = 0.0

			action.cards.c.forEach((card) => {
				const holeSuit = card.s[1] + card.s[3]
				const checkCombo = filter.combos.includes(card.com)
				const checkDraw = filter.draws.includes(card.draw)
				const checkSuits = filter.suits.includes(holeSuit)

				if (
					s1 &&
					s2 &&
					card.s[1] === s1 &&
					card.s[3] === s2 &&
					checkCombo &&
					checkDraw &&
					checkSuits &&
					card.abs > threshold
				) {
					a_sum += card.val * card.abs
					action_abs += card.abs
				}

				if (!s1 && !s2 && checkCombo && checkDraw && checkSuits && card.abs > threshold) {
					a_sum += card.val * card.abs
					action_abs += card.abs
				}
			})

			// normalize to sum
			a_sum /= action_abs
			const x = 100 * a_sum
			const defaultCellHeight = 50

			let weightHeight = ((defaultCellHeight * abs) / defaultCellHeight) * 100

			let weightWidth = x + gradientWidth

			if (isMultiStack) {
				weightHeight = 100
				weightWidth = x * abs + gradientWidth
			}

			gradientWidth = weightWidth

			gradientWidthArray.push(`${weightWidth}% ${weightHeight}%`)
		})
	}

	return gradientWidthArray
}

export const getStructureWithSameCountOfAction = (multiStackData, actionsOrder) => {
	let copyData = JSON.parse(JSON.stringify(multiStackData))

	const reducedArrBiggestAction = getReducedArrBiggestAction(copyData, actionsOrder)

	let structureWithSameCountOfAction = []

	if (reducedArrBiggestAction) {
		structureWithSameCountOfAction = copyData.map((strategy) => {
			if (strategy.length === reducedArrBiggestAction.length) {
				return strategy
			}

			let singleStack = strategy.slice()

			for (let i = 0; i < reducedArrBiggestAction.length; i++) {
				const comparedAction = singleStack[i]
				const actionForCompare = reducedArrBiggestAction[i]

				const sameAction = singleStack.find((item) => getSameAction(item, actionForCompare))

				if (sameAction) {
					comparedAction.id = i
				} else {
					singleStack.splice(i, 0, null)
				}
			}

			return singleStack
		})
	}

	return { structureWithSameCountOfAction, reducedArrBiggestAction }
}

export const getRevertedActions = (actions) => {
	let revertedActions = []

	Object.entries(actions).map(([_, val]) => {
		revertedActions.push(val)
	})

	return revertedActions.reverse().reduce((acc, current) => {
		acc[current.action] = current

		return acc
	}, {})
}

export const customSortTableData = (pagination, filters, sort, tableData, setRenderTableData) => {
	const field = sort.field
	const sortOrder = sort.order

	const sortedTable = tableData.slice().sort((a, b) => {
		if (sortOrder === 'descend') {
			return +b[field] - +a[field]
		}

		if (sortOrder === 'ascend') {
			return +a[field] - +b[field]
		}

		if (!sortOrder) {
			return null
		}
	})

	setRenderTableData(sortedTable)
}

export const customSortFuncToFlopAgg = (
	sort,
	tableData,
	setRenderTableData,
	activeActions,
	rows,
	clusters_name,
	from,
	to
) => {
	const field = sort.field
	const sortOrder = sort.order

	const activeAction = activeActions[0]

	const sortedTable = tableData.slice().sort((a, b) => {
		const index = clusters_name.slice(from, to).findIndex((name) => name === field)

		const aWeight = a.Strat.clusterWeights[index]
		const bWeight = b.Strat.clusterWeights[index]

		const aRowActiveAction = a[field][activeAction]
		const bRowActiveAction = b[field][activeAction]

		if (sortOrder === 'descend') {
			if (activeActions.length === 0) {
				if (aWeight > 0 && bWeight > 0) {
					return bWeight - aWeight
				}

				if (aWeight > 0) {
					return -1
				}

				if (bWeight > 0) {
					return 1
				}
			}

			if (activeActions.length > 0) {
				if (aRowActiveAction > 0 && bRowActiveAction > 0) {
					return bRowActiveAction - aRowActiveAction
				}

				if (aRowActiveAction > 0) {
					return -1
				}
				if (bRowActiveAction > 0) {
					return 1
				}
			}
		}

		if (sortOrder === 'ascend') {
			if (activeActions.length === 0) {
				if (aWeight > 0 && bWeight > 0) {
					return aWeight - bWeight
				}

				if (aWeight > 0) {
					return -1
				}
				if (bWeight > 0) {
					return 1
				}
			}

			if (activeActions.length > 0) {
				if (aRowActiveAction > 0 && bRowActiveAction > 0) {
					return aRowActiveAction - bRowActiveAction
				}

				if (aRowActiveAction > 0) {
					return -1
				}
				if (bRowActiveAction > 0) {
					return 1
				}
			}
		}

		if (!sortOrder) {
			return null
		}
	})

	setRenderTableData(sortedTable)
}

export const shadowVariable = {
	none: '',
	dropped: 'var(--drop-shadow)',
	raised: 'var(--raised-shadow)',
	outlined: 'var(--outlined-shadow)',
}
